export * from './ProductCardV2HoverImage.web';
